/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './ChatGptMessage-ActionTypes';

export const getChatgptGiftMessage = (
    cartItemId,
    chatGptData,
    handleCallBack,
) => ({
    type: actionTypes.GET_CHATGPT_GIFT_MESSAGE,
    data: {
        cartItemId,
        chatGptData,
        handleCallBack,
    },
});

export const updateChatgptGiftMessage = (
    cartItemId,
    chatGptData,
) => ({
    type: actionTypes.UPDATE_CHATGPT_GIFT_MESSAGE,
    data: {
        cartItemId,
        chatGptData,
    },
});

export const updateSelectedChatgptGiftMessage = (data) => ({
    type: actionTypes.UPDATE_SELECTED_CHATGPT_GIFT_MESSAGE,
    data,
});

export const clearAllChatgptMessage = (data) => ({
    type: actionTypes.CLEAR_ALL_CHATGPT_GIFT_MESSAGE,
    data,
});

export default {};
